import { useEffect } from 'react';
import useRequest from '@gp/hooks/useRequest';
import { queryRecord, pushRecord } from '@gp/services/project';
import { HISTORY_PAGE_TYPES } from '@gp/constants/const';

import type { IProjectDTO } from '@gp/types/projectDetail';

const PIPELINE_PROJECT_DETAILS_HISTORY_TYPE = HISTORY_PAGE_TYPES.PIPELINE_PROJECT_DETAILS;

const queryRecordsDomain = () => {
  return queryRecord({ type: PIPELINE_PROJECT_DETAILS_HISTORY_TYPE });
};

export default function useProjectsRecords() {
  const { loading, data, run: queryRecordsRun } = useRequest(queryRecordsDomain, { manual: true });

  const { run: pushRecordRun } = useRequest(pushRecord, {
    manual: true,
    onSuccess: () => {
      queryRecordsRun();
    },
  });

  const handlePushRecord = (data?: IProjectDTO | null) => {
    if (!data) return;
    const { project_id: projectId, project, cover, platform, studio_entity_id: studioId } = data;
    pushRecordRun({
      id: '',
      // @ts-ignore
      img: cover || '',
      name: project || '',
      platform: platform || '',
      project_id: projectId || '',
      source_type: 0,
      studio_id: studioId || '',
      type: PIPELINE_PROJECT_DETAILS_HISTORY_TYPE,
    });
  };

  useEffect(() => {
    queryRecordsRun();
  }, []);

  return { loading, data, onPushRecord: handlePushRecord, projectsRecordsRefresh: queryRecordsRun };
}
